const XMLHttpRequest = require("xmlhttprequest").XMLHttpRequest;

let transmissionCount = 0,
  lastTransmissionAttempt = new Date().getTime();
const DCR_BASE_URLS = {
  localhost: "http://localhost:51860",
  "formtest.dcrgraphs.net": "https://wwwtest.dcrgraphs.net:43443",
  "formdemo.dcrgraphs.net": "https://wwwdemo.dcrgraphs.net:43443",
  "form.dcrgraphs.net": "https://www.dcrgraphs.net/",
};

const capture = (log) => {
  console.error(
    "%c %s",
    "color: white; background:#981111; font-weight: bold; font-size:16px;",
    "EXCEPTION:",
    log
  );
  postLog(log);
};

const failed = (log) => {
  console.log("logger.failed");
  console.log(
    "%c %s",
    "color: white; background:#ff8209; font-weight: bold; font-size:16px;",
    "FAILED:",
    log
  );
  postLog(log);
};

const error = (log) => {
  console.log("logger.error");
  console.error(
    "%c %s",
    "color: white; background:red; font-weight: bold; font-size:16px;",
    "ERROR:",
    log
  );
  postLog(log);
};

const info = (log) => {
  console.info(
    "%c %s",
    "color: white; background:#44bae9; font-weight: bold; font-size:16px;",
    "INFO:",
    log
  );
};

const log = (log) => {
  console.log("%c %s", "font-weight: bold; font-size:14px;", "LOG:", log);
};

const postLog = (log) => {
  const now = new Date().getTime();
  if (lastTransmissionAttempt + 1000 >= now) {
    // if in cooldown period
    lastTransmissionAttempt = now;
    transmissionCount++;
    if (transmissionCount > 3) return;
  } else {
    transmissionCount = 0;
    lastTransmissionAttempt = now;
  }

  pushRequest(log);
};

const pushRequest = (log) => {
  const xmlhttp = new XMLHttpRequest();
  xmlhttp.onload = function (e) {
    logger.log(xmlhttp.responseText);
  };

  xmlhttp.onerror = function (e) {
    logger.failed({
      message: "Error fetching " + xmlhttp.responseURL,
    });
  };

  xmlhttp.onreadystatechange = function () {
    console.log("XMLHTTP STATUS: " + xmlhttp.status);
    if (xmlhttp.status == 404) {
      logger.failed({
        message: xmlhttp.status + " " + xmlhttp.responseURL,
      });
    }

    if (xmlhttp.readyState === 4 && xmlhttp.status === 204) {
      logger.info({
        message: "ERROR log Posted: " + log.message,
      });
    }
  };

  xmlhttp.open(
    "POST",
    `${DCR_BASE_URLS[window.location.hostname]}/api/ErrorLog`
  );
  xmlhttp.setRequestHeader("Content-Type", "application/json; charset=utf-8");
  xmlhttp.send(JSON.stringify(log));
};

const logger = {
  version: "1.0.0",
  log,
  capture,
  info,
  failed,
  error,
};

export default logger;
